module.exports = __webpack_public_path__ + "static/media/9.5ecbf4bb.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/9.mp3
// module id = 88
// module chunks = 0